// extracted by mini-css-extract-plugin
module.exports = {"bg":"newsletterSignup-module--bg--vf2_q","button":"newsletterSignup-module--button--2es3J","small":"newsletterSignup-module--small--2-1sb"};